import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {AuthService} from "../../../services/auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class RegistrationsService {
  private apiUrl!: string; // URL de l'API des enregistrements

  constructor(
    private http: HttpClient,
    private authService: AuthService // Injectez le service d'authentification
  ) {
    // Obtenez le domaine sélectionné à partir du service d'authentification
    const selectedDomain = this.authService.getSelectedDomain();
    if (selectedDomain && selectedDomain.domainName) {
      this.apiUrl = `${selectedDomain.domainName}/api/registrations`;
    } else {
      console.error('Selected domain is not set.');
    }
  }
  list(page: number, pageSize: number, slug: string, search: string, priority: any, contact_id: any, property_id: any): Observable<any> {

    let contact = '';
    if (contact_id !== null) {
      contact = contact_id.toString();
    }


    let property = '';
    if (property_id !== null) {
      property = property_id.toString();
    }


    // Set up the query parameters
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('status', priority)
      .set('search', search.toString())
      .set('contact_id', contact)
      .set('property_id', property);



    // Make the API call with the query parameters
    if(slug) {
      return this.http.get(this.apiUrl + '/' + slug, { params });
    }
    return this.http.get(this.apiUrl, { params });
  }

  createContact(propertyData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/createOrUpdate`, propertyData);
  }



  getContactDetail(contactId: string): Observable<any> {
    // Make the API call to get contact details
    return this.http.get(`${this.apiUrl}/get/${contactId}`);
  }

  delete(contactId: any): Observable<any> {
    return this.http.delete(`${this.apiUrl}/delete/${contactId}`);
  }
}
